import {Component, Inject, OnInit} from '@angular/core';
import {HttpService} from '../../../../../../../core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-lawyer-info-unlink',
  templateUrl: './lawyer-info-unlink.component.html',
  styleUrls: ['./lawyer-info-unlink.component.scss'],
})

export class LawyerInfoUnlinkComponent implements OnInit {
  constructor(private httpService: HttpService,
              private dialogRef: MatDialogRef<any>,
              private toastrService: ToastrService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit(): void {
  }


  unlinkLawyer() {
    this.httpService.unlinkLawyerInfoByDevAdmin(this.data.lawyer.id, this.data.property.id).subscribe((res: any) => {
      if (res.code === 1) {
        this.toastrService.success('Lawyer has been unlinked');
        this.dialogRef.close({code: 1});
      } else {
        this.toastrService.error('Failed to unlink lawyer');
        this.dialogRef.close({code: 0});
      }
    });
  }

  cancel() {
    this.dialogRef.close();
  }
}
